import { NAMES, SYS_NAMES } from './SecondDocumentForm.constants';

export const getDefaultValue = () => ({
  currentSecondDocumentTypeSysName: '',
  currentSecondDocumentType: { id: 0, sysName: '', value: '' },
  [NAMES.SNILS]: { id: 0, number: '' },
  [NAMES.DRIVER_LICENSE]: { seriesNumber: '', series: '', number: '', issueDate: '' },
  [NAMES.MILITARY_ID]: {
    id: 0,
    series: '',
    number: '',
    seriesNumber: '',
    issueDate: '',
    issuer: '',
  },
  [NAMES.INTERNATIONAL_PASSPORT]: {
    id: 0,
    series: '',
    number: '',
    seriesNumber: '',
    issueDate: '',
    issuer: '',
    expires: '',
  },
  [NAMES.TAX_REGISTRATION]: {
    id: 0,
    inn: '',
    series: '',
    number: '',
    seriesNumber: '',
    issueDate: '',
    issuer: '',
    startDate: '',
    whereGivenOut: '',
  },
});

export const getDocTypeField = (docType) => {
  switch (docType?.sysName) {
    case SYS_NAMES.SECOND_PENSION:
      return `${NAMES.SNILS}.number`;
    case SYS_NAMES.SECOND_FOREIGN_PASSPORT:
      return `${NAMES.INTERNATIONAL_PASSPORT}.seriesNumber`;
    case SYS_NAMES.SECOND_TAX:
      return `${NAMES.TAX_REGISTRATION}.inn`;
    case SYS_NAMES.SECOND_MILITARY:
      return `${NAMES.MILITARY_ID}.seriesNumber`;
    default:
      return `${NAMES.DRIVER_LICENSE}.seriesNumber`;
  }
};

export const getDocTypeName = (docType) => {
  switch (docType?.sysName) {
    case SYS_NAMES.SECOND_PENSION:
      return NAMES.SNILS;
    case SYS_NAMES.SECOND_FOREIGN_PASSPORT:
      return NAMES.INTERNATIONAL_PASSPORT;
    case SYS_NAMES.SECOND_TAX:
      return NAMES.TAX_REGISTRATION;
    case SYS_NAMES.SECOND_MILITARY:
      return NAMES.MILITARY_ID;
    default:
      return NAMES.DRIVER_LICENSE;
  }
};
